import { render } from "./ViewRejectPaymentRevesals.vue?vue&type=template&id=1f4fdb31&scoped=true"
import script from "./ViewRejectPaymentRevesals.vue?vue&type=script&lang=js"
export * from "./ViewRejectPaymentRevesals.vue?vue&type=script&lang=js"

import "./ViewRejectPaymentRevesals.vue?vue&type=style&index=0&id=1f4fdb31&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f4fdb31"]])

export default __exports__